import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__grid">
        <div>
          <h3>Rajarata Rice Mills</h3>
          <p>Premium Sri Lankan rice, milled at source and delivered with consistent quality.</p>
        </div>
        <div>
          <h4>Contact</h4>
          <ul>
            <li>Hotline: +94 77 123 4567</li>
            <li>Email: hello@rajaratarice.lk</li>
            <li>Kurunegala, North Western Province</li>
          </ul>
        </div>
        <div>
          <h4>Navigate</h4>
          <div className="footer__links">
            <Link to="/">Home</Link>
            <Link to="/products">Products</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <span> {new Date().getFullYear()} RAJARATA SAHAL © All rights reserved.</span>
        <span>Freshly milled. Locally sourced. Export ready.</span>
      </div>
    </footer>
  );
}

export default Footer;
